// AcceptServiceOrderReqWithDiscCustPage.js
import React, { useEffect, useState } from "react";
import { FaCheck, FaTimes } from "react-icons/fa";
import "../../../invite.css";

const AcceptServiceOrderReqWithDiscCustPage = () => {
  const [loading, setLoading] = useState(true);
  const [success, setSuccess] = useState(null);
  const [errorMsg, setErrorMsg] = useState("");
  const BASE_URL = process.env.REACT_APP_API_URL;

  useEffect(() => {
    const queryParams = new URLSearchParams(window.location.search);
    const mainId = queryParams.get("pvid");
    const custid = queryParams.get("uid");

    const handleAccept = async () => {
      if (!BASE_URL) {
        console.error("❌ Missing REACT_APP_API_URL in .env");
        setSuccess(false);
        setLoading(false);
        return;
      }

      if (!mainId || !custid) {
        console.warn("❌ Missing required query params (pvid / uid)");
        setErrorMsg("Invalid request link.");
        setSuccess(false);
        setLoading(false);
        return;
      }

      try {
        const response = await fetch(
          `${BASE_URL}/WorkOrderRequest/Approve_WorkOrderRequest_By_Customer`,
          {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({
              workOrderRequestID: parseInt(mainId, 10),
              customerID: parseInt(custid, 10),
              statusID: 1, // 1 = Accept
            }),
          }
        );

        const data = await response.json();

        if (!response.ok) {
          throw new Error(`Approval failed: ${response.status} ${data.message || ""}`);
        }

        if (data.isSuccess) {
          setSuccess(true);
        } else {
          setErrorMsg(data.message || "Approval failed.");
          setSuccess(false);
        }
      } catch (err) {
        console.error("❌ Error approving request:", err);
        setErrorMsg(err.message);
        setSuccess(false);
      } finally {
        setLoading(false);
      }
    };

    handleAccept();
  }, [BASE_URL]);

  if (loading) {
    return (
      <div className="center-screen">
        <div className="loader-container" aria-live="polite">
          <img
            src="/Montdor_1.png"
            alt="Company Logo"
            className="company-logo"
            onError={(e) => (e.target.style.display = "none")}
          />
          <div className="spinner"></div>
          <p className="loader-text">Processing your request...</p>
        </div>
      </div>
    );
  }

  return (
    <div className="center-screen" style={{ backgroundColor: "#2c2139" }}>
      <div className="card-box">
        {success ? (
          <>
            <div className="icon">
              <FaCheck size={48} color="#28a745" />
            </div>
            <h2 className="card-title">Approved</h2>
            <p className="card-msg">Additional Item has been Approved.</p>
          </>
        ) : (
          <>
            <div className="icon">
              <FaTimes size={48} color="#e74c3c" />
            </div>
            <h2 className="card-title">Error</h2>
            <p className="card-msg">
              {errorMsg || "Unable to approve Additional Item."}
            </p>
          </>
        )}
      </div>
    </div>
  );
};

export default AcceptServiceOrderReqWithDiscCustPage;
